import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import multi from 'redux-multi';
import promise from 'redux-promise';
import thunkMiddleware from 'redux-thunk';

import reducers from '../../reducers';
import Page from './page';

const middleware = composeWithDevTools(applyMiddleware(promise, multi, thunkMiddleware))

const store = createStore(reducers, middleware)

const MfaLogin = (props) => {
    return (<Provider store={store}>
        <Page {...props} />
    </Provider>)
}

export default MfaLogin